import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { staticInOut } from '../router.animations';
import { LayoutService } from '../layout.service';
import { ApiService } from '../api.service';
import { SplashService } from '../splash.service';
import { Meta } from '@angular/platform-browser';
import { Observable } from 'rxjs/Rx';
import { assign } from 'lodash';

@Component({
  selector: 'app-home-view',
  templateUrl: './home-view.component.html',
  styleUrls: ['./home-view.component.scss'],
  animations: [
    staticInOut,
    trigger('splashState', [
      state('hidden', style({
        opacity: '0',
        display: 'none'
      })),
      state('visible',   style({
        opacity: '1',
        display: 'block'
      })),
      transition('hidden => visible', animate('400ms ease-in')),
      transition('visible => hidden', animate('400ms ease-out'))
    ])
  ],
  host: {
    '[@staticInOut]': ''
  }
})
export class HomeViewComponent implements OnInit {
  items: any[];
  startPosition: any;
  poster: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ApiService: ApiService,
    private metaService: Meta,
    public LayoutService: LayoutService,
    private SplashService: SplashService
  ) {
    this.getApiData().then(apiData => {
      if (typeof apiData.splashscreen !== 'undefined' && !this.LayoutService.haveShownSplashscreen) {
        this.LayoutService.showSplashscreen = apiData.splashscreen;
        this.LayoutService.haveShownSplashscreen = true;
        this.SplashService.backgroundImages = apiData.splashscreenBgImages;
        this.SplashService.titleImage = {
          desktop: apiData.title_image,
          mobile: apiData.title_mobile_image
        }
      } else {
        this.LayoutService.showSplashscreen = false;
      }

      this.items = apiData.items;

      this.startPosition = {
        left: -apiData.start_position_x,
        top: -apiData.start_position_y
      };
      this.poster = {
        width: apiData.poster_size_x,
        height: apiData.poster_size_y
      }

      this.metaService.updateTag({ name: 'keywords', content: 'Danny Lane' });
      this.metaService.updateTag({ name: 'description', content: 'Danny Lane' });
    });
  }

  getApiData() {
    return Observable.combineLatest(
      this.ApiService.getData(`splashscreen/current`),
      this.ApiService.getData(`homepage_settings`),
      this.ApiService.getData(`homepage_layout`)
    )
    .toPromise()
    .then(([splashscreen, homepageSettings, homepageLayout]) => {
      return assign({}, homepageSettings['homepage_settings'][0], {
        items: homepageLayout['homepage_layout'],
        splashscreenBgImages: splashscreen['splashscreen']
      });
    })
    .catch((error) => {
      return null;
    });
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/home-view/home-view.component.ts